function Baseball({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM11.22 33.56C9.2 30.9 8 27.6 8 24C8 20.4 9.2 17.1 11.22 14.44C14.12 16.62 16 20.1 16 24C16 27.9 14.12 31.38 11.22 33.56ZM24 40C20.22 40 16.74 38.68 14 36.48C17.66 33.54 20 29.06 20 24C20 18.94 17.66 14.46 14 11.52C16.74 9.32 20.22 8 24 8C27.78 8 31.26 9.32 34 11.52C30.34 14.46 28 18.94 28 24C28 29.06 30.34 33.54 34 36.48C31.26 38.68 27.78 40 24 40ZM36.78 33.56C33.88 31.38 32 27.9 32 24C32 20.1 33.88 16.62 36.78 14.44C38.8 17.1 40 20.4 40 24C40 27.6 38.8 30.9 36.78 33.56Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Baseball;
